import { IContextualMenuItem, mergeStyles, MessageBar, MessageBarType } from "@fluentui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { logEvent, logException } from "../../../helper/AppInsightsHelper";
import { AllFilters } from "../../../interfaces/allFilterData";
import { CustomFilterPill } from "../../../SharedComponents/CustomFilterPill";
import { useGetFiltersQuery } from "../../../slices/Common.slice";
import { mapFilterPillMenuItemsPredicate } from "../../CustomerSearch/CustomerSearch.common";
import { CUSTOMER_SEARCH_STYLES } from "../../CustomerSearch/CustomerSearch.styles";

export const ProductFilterPill = (props: any) => {
  const navigate = useNavigate();
  const defaultValue = "All";

  const [regions, setRegions] = useState<IContextualMenuItem[]>([]);
  const [selectedRegions, setSelectedRegions] = useState<string[]>([]);
  const [segmentGroups, setSegmentGroups] = useState<IContextualMenuItem[]>([]);
  const [selectedSegmentGroups, setSelectedSegmentGroups] = useState<string[]>([]);
  const [subSegments, setSubSegments] = useState<IContextualMenuItem[]>([]);
  const [selectedSubSegments, setSelectedSubSegments] = useState<string[]>([]);
  const [hasPartners, setHasPartners] = useState<IContextualMenuItem[]>([]);
  const [selectedHasPartner, setSelectedHasPartner] = useState<string[]>([]);
  const [isFastTracks, setIsFastTracks] = useState<IContextualMenuItem[]>([]);
  const [selectedFastTrack, setSelectedFastTrack] = useState<string[]>([]);
  const [isCATs, setIsCATs] = useState<IContextualMenuItem[]>([]);
  const [selectedIsCAT, setSelectedIsCAT] = useState<string[]>([]);
  const [isS500, setIsS500] = useState<IContextualMenuItem[]>([]);
  const [selectedIsS500, setSelectedIsS500] = useState<string[]>([]);
  const [isTCT, setIsTCT] = useState<IContextualMenuItem[]>([]);
  const [selectedIsTCT, setSelectedIsTCT] = useState<string[]>([]);
  const [isCCP, setIsCCP] = useState<IContextualMenuItem[]>([]);
  const [selectedIsCCP, setSelectedIsCCP] = useState<string[]>([]);
  const [majorGrowth, setMajorGrowth] = useState<IContextualMenuItem[]>([]);
  const [selectedMajorGrowth, setSelectedMajorGrowth] = useState<string[]>([]);
  const [products, setProducts] = useState<any[]>([]);
  const [allData, setAllData] = useState<AllFilters>();
  const { data, error } = useGetFiltersQuery(null);
  const filterPillsData = [
    {
      key: "productFilterPillForRegion",
      name: "Region",
      items: regions,
      urlParamKey: "regions",
      setSelectedItems: setSelectedRegions
    },
    {
      key: "productFilterPillForSegmentGroup",
      name: "Segment Group",
      items: segmentGroups,
      urlParamKey: "segmentGroups",
      setSelectedItems: setSelectedSegmentGroups
    },
    {
      key: "productFilterPillForSubSegment",
      name: "Sub Segment",
      items: subSegments,
      setSelectedItems: setSelectedSubSegments,
      urlParamKey: "subSegments"
    },
    {
      key: "productFilterPillForHasPartner",
      name: "HasPartner",
      items: hasPartners,
      setSelectedItems: setSelectedHasPartner,
      urlParamKey: "hasPartners"
    },
    {
      key: "productFilterPillForIsFastTrack",
      name: "IsFastTrackStrategic",
      items: isFastTracks,
      setSelectedItems: setSelectedFastTrack,
      urlParamKey: "isFastTrackStrategic"
    },
    {
      key: "productFilterPillForIsCAR",
      name: "IsCAT ",
      items: isCATs,
      setSelectedItems: setSelectedIsCAT,
      urlParamKey: "isCAT"
    },
    {
      key: "productFilterPillForIsS500",
      name: "IsS500 ",
      items: isS500,
      setSelectedItems: setSelectedIsS500,
      urlParamKey: "isS500"
    },
    {
      key: "productFilterPillForIsTCT",
      name: "IsTCT ",
      items: isTCT,
      setSelectedItems: setSelectedIsTCT,
      urlParamKey: "isTCT"
    },
    {
      key: "productFilterPillForIsCCP",
      name: "IsSecurityAdvisor",
      items: isCCP,
      setSelectedItems: setSelectedIsCCP,
      urlParamKey: "isCCP"
    },
    {
      key: "productFilterPillForMajorGrowth",
      name: "MajorGrowth ",
      items: majorGrowth,
      setSelectedItems: setSelectedMajorGrowth,
      urlParamKey: "majorGrowth"
    }
  ];

  useEffect(() => {
    const customProps = {
      ProductViewFilters: props
    };
    if (data) {
      setAllData(data);
      const productValue: any[] = [];
      if (products?.length === 0) {
        data?.productNames?.forEach((element: any) => {
          productValue.push({ label: element.productName, value: element.productId });
        });
        setProducts(productValue);
      }
      setRegions(((data?.regionNames as string[]) || []).map(mapFilterPillMenuItemsPredicate));
      const segmentValue: Set<string> = new Set();
      const subSegmentValue: Set<string> = new Set();
      const segmentGroupValue: Set<string> = new Set();
      data?.segmentGroups?.forEach((group: any) => {
        segmentGroupValue.add(group.segmentGroupName);
        group.segments.forEach((segment: any) => {
          segmentValue.add(segment.segmentName);
          segment.subSegments.forEach((subSegment: string) => {
            subSegmentValue.add(subSegment);
          });
        });
      });
      setSubSegments(Array.from(subSegmentValue).map(mapFilterPillMenuItemsPredicate));
      setSegmentGroups(Array.from(segmentGroupValue).map(mapFilterPillMenuItemsPredicate));
      setHasPartners(["Yes", "No"].map(mapFilterPillMenuItemsPredicate));
      setIsFastTracks(["Yes", "No"].map(mapFilterPillMenuItemsPredicate));
      setIsCATs(["Yes", "No"].map(mapFilterPillMenuItemsPredicate));
      setIsS500(["Yes", "No"].map(mapFilterPillMenuItemsPredicate));
      setIsTCT(["Yes", "No"].map(mapFilterPillMenuItemsPredicate));
      setIsCCP(["Yes", "No"].map(mapFilterPillMenuItemsPredicate));
      setMajorGrowth(["Major Upper", "Major Growth"].map(mapFilterPillMenuItemsPredicate));
      logEvent("useGetFiltersQuery API call success", "Product View", "FilterPillProduct", customProps);
    }
    if (error) {
      logException("Product View", "FilterPillProduct", "useGetFiltersQuery", error, customProps);
    }
  }, [data]);
  useEffect(() => {
    let newRegionValue: string = "";
    selectedRegions.forEach((element: string) => {
      newRegionValue = element + ";" + newRegionValue;
    });

    let newSegmentGroupValue: string = "";
    selectedSegmentGroups.forEach((element: string) => {
      newSegmentGroupValue = element + ";" + newSegmentGroupValue;
    });
    if (!selectedSegmentGroups || selectedSegmentGroups?.length === 0) {
      const segmentValue: Set<string> = new Set();
      const subSegmentValue: Set<string> = new Set();
      const segmentGroupValue: Set<string> = new Set();
      data?.segmentGroups?.forEach((group: any) => {
        segmentGroupValue.add(group.segmentGroupName);
        group.segments.forEach((segment: any) => {
          segmentValue.add(segment.segmentName);
          segment.subSegments.forEach((subSegment: string) => {
            subSegmentValue.add(subSegment);
          });
        });
      });
      setSubSegments(Array.from(subSegmentValue).map(mapFilterPillMenuItemsPredicate));
      setSegmentGroups(Array.from(segmentGroupValue).map(mapFilterPillMenuItemsPredicate));
    } else {
      const filteredSegments: Set<string> = new Set();
      const filteredSubSegments: Set<string> = new Set();

      if (selectedSegmentGroups && selectedSegmentGroups.length > 0) {
        allData?.segmentGroups.forEach((group: any) => {
          if (selectedSegmentGroups.includes(group.segmentGroupName)) {
            group.segments.forEach((seg: any) => {
              filteredSegments.add(seg.segmentName);
              seg.subSegments.forEach((subSeg: string) => {
                filteredSubSegments.add(subSeg);
              });
            });
          }
        });
      }

      if (!selectedSegmentGroups || selectedSegmentGroups.length === 0) {
        allData?.segmentGroups.forEach((group: any) => {
          group.segments.forEach((seg: any) => {
            filteredSegments.add(seg.segmentName);
          });
        });
      }

      setSubSegments(Array.from(filteredSubSegments).map(mapFilterPillMenuItemsPredicate));
    }
    let newSubSegmentValue: string = "";
    selectedSubSegments.forEach((element: string) => {
      newSubSegmentValue = element + ";" + newSubSegmentValue;
    });
    let newPartnerValue: string = "";
    selectedHasPartner.forEach((element: string | string[]) => {
      newPartnerValue = selectedHasPartner.length > 1 ? "" : element.includes("Yes") ? "1" : "0";
    });
    let newIsCatValue: string = "";
    selectedIsCAT.forEach((element: string | string[]) => {
      newIsCatValue = selectedIsCAT.length > 1 ? "" : element.includes("Yes") ? "1" : "0";
    });
    let newIsS500Value: string = "";
    selectedIsS500.forEach((element: string | string[]) => {
      newIsS500Value = selectedIsS500.length > 1 ? "" : element.includes("Yes") ? "1" : "0";
    });
    let newIsTCTValue: string = "";
    selectedIsTCT.forEach((element: string | string[]) => {
      newIsTCTValue = selectedIsTCT.length > 1 ? "" : element.includes("Yes") ? "1" : "0";
    });
    let newIsCCPValue: string = "";
    selectedIsCCP.forEach((element: string | string[]) => {
      newIsCCPValue = selectedIsCCP.length > 1 ? "" : element.includes("Yes") ? "1" : "0";
    });
    let newMajorGrowthValue: string = "";
    selectedMajorGrowth.forEach((element: string | string[]) => {
      newMajorGrowthValue =
        selectedMajorGrowth.length > 1 ? "" : element.includes("Major Upper") ? "Major Upper" : "Major Growth";
    });
    let newFastTrackValue: string = "";
    selectedFastTrack?.forEach((element: string | string[]) => {
      newFastTrackValue = selectedFastTrack?.length > 1 ? "" : element.includes("Yes") ? "1" : "0";
    });
    props.onRegionChange(newRegionValue);
    props.onSubSegmentChange(newSubSegmentValue);
    props.onFastTrackChange(newFastTrackValue);
    props.onPartnerChange(newPartnerValue);
    props.onIsCatChange(newIsCatValue);
    props.onSegmentGroupChange(newSegmentGroupValue);
    props.onIsS500Change(newIsS500Value);
    props.onIsCCPChange(newIsCCPValue);
    props.onIsTCTChange(newIsTCTValue);
    props.onMajorGrowthChange(newMajorGrowthValue);
  }, [
    selectedRegions,
    selectedSegmentGroups,
    selectedSubSegments,
    selectedHasPartner,
    selectedFastTrack,
    selectedIsCAT,
    selectedIsS500,
    selectedIsTCT,
    selectedIsCCP,
    selectedMajorGrowth
  ]);
  const handleProductChange = (selectedOption: any) => {
    if (selectedOption.label !== undefined) {
      props.onProductChange(selectedOption.label);
      navigate(
        "/productview?productname=" +
          encodeURIComponent(selectedOption.label) +
          "&productid=" +
          encodeURIComponent(selectedOption.value)
      );
    }
  };

  return (
    <div
      className={mergeStyles({
        alignItems: "flex-start",
        display: "flex",
        flexWrap: "nowrap",
        justifyContent: "space-between",
        padding: 12
      })}
    >
      <div style={{ display: "flex", flexWrap: "wrap", flex: 1, marginRight: props.hideFilters ? 16 : 0 }}>
        {props.hideFilters ? (
          <MessageBar messageBarType={MessageBarType.info} styles={{ root: { width: "100%" } }}>
            Top-level tenant filters are not applicable to the Partner Influence tab.
          </MessageBar>
        ) : filterPillsData.map((pill) => (
          <CustomFilterPill
            defaultValue={defaultValue}
            isRemovable
            key={pill.key}
            name={pill.name}
            urlParamKey={pill.urlParamKey}
            menuProps={{
              focusZoneProps: {
                /* Allow up and down arrows to move focus out of the SearchBox */
                shouldInputLoseFocusOnArrowKey: () => true
              },
              items: pill.items
            }}
            onApply={(selectedItems) => pill.setSelectedItems(selectedItems || [])}
            onCancel={(previouslyselectedItem) => pill.setSelectedItems(previouslyselectedItem || [])}
            onResetFilters={() => pill.setSelectedItems([])}
            styles={CUSTOMER_SEARCH_STYLES.CUSTOMER_SEARCH_FILTER_PILL.STYLES}
          />
        ))}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px"
        }}
      >
        <label>Product Name:</label>
        <div style={{ width: 300 }}>
          <Select
            defaultValue={{
              label: props.productName,
              value: props.productName
            }}
            value={{ label: props.productName, value: props.productName }}
            onChange={handleProductChange}
            options={products}
            isSearchable={true}
            menuPortalTarget={document.body}
            aria-label="Product Name Search"
          />
        </div>
      </div>
    </div>
  );
};
